import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";

import {
  ESupportTicketSource,
  SupportTicketResponse,
} from "../../aiTickets.types";
import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import { requestTicketTranscript } from "./transcript.request";
import { TranscriptMessage } from "./transcript.types";

const conversationIdOf = (ticket: SupportTicketResponse): string | null =>
  ticket.source === ESupportTicketSource.WhatsApp
    ? ticket.whatsappConversationId
    : ticket.inAppConversationId;

export const useTicketTranscript = (ticket: SupportTicketResponse | null) => {
  const conversationId = ticket ? conversationIdOf(ticket) : null;

  const query = useQuery<TranscriptMessage[], ApiServiceError<ApiError>>({
    queryKey: [
      SUPPORT_TICKETS_QUERY_KEY,
      "transcript",
      ticket?.source,
      conversationId,
    ],
    queryFn: async () =>
      await requestTicketTranscript({
        source: ticket!.source,
        conversationId: conversationId!,
      }),
    enabled: Boolean(ticket && conversationId),
  });

  return {
    messages: query.data ?? [],
    isLoading: query.isLoading && Boolean(conversationId),
    hasConversation: Boolean(conversationId),
  };
};
